import { MapUtils } from '../../../utility/map-utils.js';
import { JSONUtils } from '../../../utility/json-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class HomePageParams extends DataModel {
  static readonly TYPE_ID: string = 'c14357e7515f41eb813d7ade9dabee79';

  private constructor(
    public readonly organizerIds: string[],
    public readonly eventIds: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return HomePageParams.TYPE_ID;
  }

  static create(args: { organizerIds: string[], eventIds: string[] }): HomePageParams {
    return new HomePageParams(args.organizerIds ?? [], args.eventIds ?? []);
  }

  static fromMap(context: SerializationContext, map: SerializedData): HomePageParams {
    return HomePageParams.create({
      organizerIds: MapUtils.getList(map, 'organizerIds', (d) => JSONUtils.decodeString(d)),
      eventIds: MapUtils.getList(map, 'eventIds', (d) => JSONUtils.decodeString(d)),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      organizerIds: this.organizerIds,
      eventIds: this.eventIds,
    };
  }

  clone(): this {
    return HomePageParams.create({
      organizerIds: [...this.organizerIds],
      eventIds: [...this.eventIds],
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) return true;

    return other.organizerIds === this.organizerIds && other.eventIds === this.eventIds;
  }
}

export class HomePageParamsBuilder extends DataModelBuilder<HomePageParams> {
  build(context: SerializationContext, map: SerializedData): HomePageParams {
    return HomePageParams.fromMap(context, map);
  }
}
